import React from "react";
import { Link } from "react-router-dom";
import {
  LocalShippingOutlined,
  WarehouseOutlined,
  DriveEtaOutlined,
  PeopleAltOutlined,
  AssignmentOutlined,
  MyLocationOutlined,
  FeedOutlined,
  AccountBalanceOutlined,
  EmailOutlined,
  AssignmentReturnOutlined,
  CancelOutlined,
  WatchLaterOutlined,
  UpdateOutlined,
  StorefrontOutlined,
  QrCode2Outlined,
} from "@mui/icons-material";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import { useAuth } from "hooks";

const getIcon = (iconName) => {
  const iconStyle = { color: "primary.main", fontSize: 25 };
  const icons = {
    LocalShippingOutlined: <LocalShippingOutlined sx={iconStyle} />,
    WarehouseOutlined: <WarehouseOutlined sx={iconStyle} />,
    DriveEtaOutlined: <DriveEtaOutlined sx={iconStyle} />,
    PeopleAltOutlined: <PeopleAltOutlined sx={iconStyle} />,
    AssignmentOutlined: <AssignmentOutlined sx={iconStyle} />,
    MyLocationOutlined: <MyLocationOutlined sx={iconStyle} />,
    FeedOutlined: <FeedOutlined sx={iconStyle} />,
    EmailOutlined: <EmailOutlined sx={iconStyle} />,
    AccountBalanceOutlined: <AccountBalanceOutlined sx={iconStyle} />,
    AssignmentReturnOutlined: <AssignmentReturnOutlined sx={iconStyle} />,
    CancelOutlined: <CancelOutlined sx={iconStyle} />,
    WatchLaterOutlined: <WatchLaterOutlined sx={iconStyle} />,
    UpdateOutlined: <UpdateOutlined sx={iconStyle} />,
    StorefrontOutlined: <StorefrontOutlined sx={iconStyle} />,
    QrCode2Outlined: <QrCode2Outlined sx={iconStyle} />,
  };
  return icons[iconName] || null;
};

const ReportListScreen = () => {
  const { isAccountAdmin, isSystemAdmin, isEntityAdmin } = useAuth();
  const isEntityUser = !isAccountAdmin && !isSystemAdmin && !isEntityAdmin;

  // Define the full list of report sections
  const reportSections = [
    {
      title: "Shipment Reports",
      items: [
        {
          title: "Late Shipment Report",
          path: "/app/crm/reports/shipment-report",
          icon: "WatchLaterOutlined",
        },
        {
          title: "Shipment Cancel Report",
          path: "/app/crm/reports/bulkCancelReport",
          icon: "CancelOutlined",
        },
        {
          title: "Returned Shipment Report",
          path: "/app/crm/reports/returnedShipmentReport",
          icon: "AssignmentReturnOutlined",
        },
        {
          title: "Shipment Misplaced",
          path: "/app/crm/reports/misplaced-shipment",
          icon: "LocalShippingOutlined",
        },
        {
          title: "Shipment W/O Price",
          path: "/app/crm/reports/no-price-shipments",
          icon: "FeedOutlined",
        },
        {
          title: "SMS Logs",
          path: "/app/crm/sms-log/list",
          icon: "EmailOutlined",
        },
        {
          title: "Unattended Shipments",
          path: "/app/crm/reports/unattended-shipments",
          icon: "EmailOutlined",
        },
        {
          title: "Average Delivery Time",
          path: "/app/crm/reports/average-delivery-time",
          icon: "LocalShippingOutlined",
        },
        {
          title: "Driver Pending Delivery List Report",
          path: "/app/crm/reports/driver-pending-delivery",
          icon: "LocalShippingOutlined",
        },
      ],
    },
    {
      title: "Warehouse Reports",
      items: [
        {
          title: "Warehouse Inventory Report",
          path: "/app/crm/warehouse/list",
          icon: "WarehouseOutlined",
        },
        {
          title: "Warehouse Allocation Report",
          path: "/app/crm/warehouse/list",
          icon: "WarehouseOutlined",
        },
        {
          title: "Incident Report",
          path: "/app/crm/incident-report/list",
          icon: "FeedOutlined",
        },
        {
          title: "Branch Shipment Location Report",
          path: "/app/crm/reports/branch-shipment-location-report",
          icon: "WarehouseOutlined",
        },
        {
          title: "Branch Tally Upload",
          path: "/app/crm/reports/branch-tally-upload/list",
          icon: "WarehouseOutlined",
        },
      ],
    },
    {
      title: "Transport Reports",
      items: [
        {
          title: "Vehicle Insurance Report",
          path: "/app/crm/vehicle/vehicleInsurance",
          icon: "AccountBalanceOutlined",
        },
        {
          title: "Vehicle Mileage Report",
          path: "/app/crm/reports/vehicleMileageReport",
          icon: "AccountBalanceOutlined",
        },
        {
          title: "Vehicle Maintenance Report",
          path: "/app/crm/vehicle-maintenance/list",
          icon: "DriveEtaOutlined",
        },
        {
          title: "Driver license",
          path: "/app/crm/driver/driverLicence",
          icon: "PeopleAltOutlined",
        },
        // {
        //   title: "Merchant Report",
        //   path: "/app/crm/reports/merchantReport",
        //   icon: "StorefrontOutlined",
        // },
      ],
    },
    {
      title: "Payment Reports",
      items: [
        // {
        //   title: "COC Collection Transaction Report",
        //   path: "/app/crm/reports/coc-report",
        //   icon: "FeedOutlined",
        // },
        // {
        //   title: "COC Collection User Report",
        //   path: "/app/crm/reports/user-coc-report",
        //   icon: "PeopleAltOutlined",
        // },
        // {
        //   title: "COD Transaction Report",
        //   path: "/app/crm/reports/delivery-report",
        //   icon: "FeedOutlined",
        // },
        // {
        //   title: "COD User Report",
        //   path: "/app/crm/reports/user-delivery-report",
        //   icon: "PeopleAltOutlined",
        // },
        {
          title: "COD Transfer Report",
          path: "/app/crm/reports/cod-report",
          icon: "FeedOutlined",
        },
        {
          title: "COD Payment Deduct Report",
          path: "/app/crm/reports/cod-charge-deduct-report",
          icon: "AccountBalanceOutlined",
        },
        // {
        //   title: "COD Service Charge Deduct Report",
        //   path: "/app/crm/reports/cod-service-charge-deduct-report",
        //   icon: "AccountBalanceOutlined",
        // },
        {
          title: "Daily Transaction Report",
          path: "/app/crm/reports/transaction-report",
          icon: "AccountBalanceOutlined",
        },
        // {
        //   title: "Sales Report"
        //   path: "/app/crm/reports/sales-report",
        //   icon: "AccountBalanceOutlined",
        // },

        {
          title: "Sales Report",
          path: "/app/crm/reports/shipment-pricing",
          icon: "AccountBalanceOutlined",
        },
        {
          title: "Branch Report",
          path: "/app/crm/reports/branch-report",
          icon: "WarehouseOutlined",
        },
        {
          title: "Pending Branch COD Report",
          path: "/app/crm/reports/cod-branch-report",
          icon: "WarehouseOutlined",
        },
        {
          title: "Pending Branch COC Report",
          path: "/app/crm/reports/coc-branch-report",
          icon: "WarehouseOutlined",
        },
        {
          title: "Pending Branch COD and COC Report",
          path: "/app/crm/reports/coc-cod-branch-report",
          icon: "WarehouseOutlined",
        },
        {
          title: "Price Change Report",
          path: "/app/crm/reports/price-change-report",
          icon: "UpdateOutlined",
        },
        {
          title: "Pending Payment Report",
          path: "/app/crm/reports/pending-payment-report",
          icon: "UpdateOutlined",
        },
        {
          title: "QR Payment Report",
          path: "/app/crm/reports/qr-payment-report",
          icon: "QrCode2Outlined",
        },
        {
          title: "GL Sales Report",
          path: "/app/crm/reports/general-ledger-sales-report",
          icon: "AccountBalanceOutlined",
        },
      ],
    },
    {
      title: "Vendor Reports",
      items: [
        {
          title: "Vendor Transaction Report",
          path: "/app/crm/reports/vendor-transaction-report",
          icon: "FeedOutlined",
        },
        {
          title: "Vendor Document Expiry Report",
          path: "/app/crm/reports/getDocumentsExpiry",
          icon: "FeedOutlined",
        },
        {
          title: "Vendor Branch Report",
          path: "/app/crm/reports/vendor-branch-report",
          icon: "FeedOutlined",
        },
        {
          title: "Vendor Wise Report",
          path: "/app/crm/reports/vendor-report",
          icon: "FeedOutlined",
        },
        {
          title: "Vendor Shipment Count",
          path: "/app/crm/reports/getVendorShipmentCounts",
          icon: "FeedOutlined",
        },
        {
          title: "Vendor RM Wise Report",
          path: "/app/crm/reports/vendor-RM-report",
          icon: "FeedOutlined",
        },
        {
          title: "Vendor Lead Status Change Report",
          path: "/app/crm/reports/vendor-lead-status-log",
          icon: "FeedOutlined",
        },
        {
          title: "Vendor Lead Note List",
          path: "/app/crm/reports/vendor-lead-note-list",
          icon: "FeedOutlined",
        },
        {
          title: "Vendor Lead Task Note List",
          path: "/app/crm/reports/vendor-lead-task-note-list",
          icon: "FeedOutlined",
        },
        {
          title: "Vendor Lead Responsible List",
          path: "/app/crm/reports/vendor-lead-responsible",
          icon: "PeopleAltOutlined",
        },
        {
          title: "Vendor Lead Analytics",
          path: "/app/crm/reports/vendor-lead-analytics",
          icon: "PeopleAltOutlined",
        },
      ],
    },
    {
      title: "Follow Ups",
      items: [
        {
          title: "Shipment Notes",
          path: "/app/crm/note-list/list",
          icon: "FeedOutlined",
        },
        {
          title: "Shipment Actions",
          path: "/app/crm/action-list/list",
          icon: "FeedOutlined",
        },
        {
          title: "Vendor W/O Documents",
          path: "/app/crm/reports/vendor-no-docs",
          icon: "FeedOutlined",
        },
        {
          title: "Shipment Charge Report",
          path: "/app/crm/reports/shipment-charge-report",
          icon: "FeedOutlined",
        },
        {
          title: "E-Bill Report",
          path: "/app/crm/reports/ebill-report",
          icon: "FeedOutlined",
        },
      ],
    },
    {
      title: "API Performance",
      items: [
        {
          title: "API Performance",
          path: "/app/crm/reports/api-performance-report",
          icon: "FeedOutlined",
        },
        {
          title: "API Performance Graph",
          path: "/app/crm/reports/api-performance-graph",
          icon: "FeedOutlined",
        },
      ],
    },
  ];

  //define for entity users
  const entityUserReports = [
    "Late Shipment Report",
    "Shipment Cancel Report",
    "Returned Shipment Report",
    "Shipment Notes",
    "Unattended Shipments",
    "QR Payment Report",
  ];

  // Restrict "API Performance" section to account/system admins only
  const isAllowedApiPerformanceViewer = isAccountAdmin || isSystemAdmin;
  const visibleReportSections = isAllowedApiPerformanceViewer
    ? reportSections
    : reportSections.filter((section) => section.title !== "API Performance");
  // Filter report sections for entity users
  const filteredReportSections = isEntityUser
    ? visibleReportSections
      .map((section) => ({
        ...section,
        items: section.items.filter((item) =>
          entityUserReports.includes(item.title)
        ),
      }))
      .filter((section) => section.items.length > 0)
    : visibleReportSections;

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Grid container spacing={3}>
        {filteredReportSections.map((section, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Paper elevation={3} sx={{ p: 1, height: "100%" }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "primary.main" }}
              >
                {section.title}
              </Typography>
              <TableContainer>
                <Table>
                  <TableBody>
                    {section.items.map((item, idx) => (
                      <TableRow
                        key={idx}
                        hover
                        sx={{ "&:hover": { backgroundColor: "action.hover" } }}
                      >
                        <TableCell sx={{ padding: "4px" }}>
                          {getIcon(item.icon)}
                        </TableCell>
                        <TableCell sx={{ padding: "4px" }}>
                          <Link
                            to={item.path}
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                              fontSize: "14px",
                            }}
                          >
                            {item.title}
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
export default ReportListScreen;
